import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound'
import BlogView from '@/components/BlogView'
import RemoteControl from '@/components/RemoteControl/RemoteControl.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/notes',
    name: 'BlogView',
    component: BlogView
  }, {
  //   path: '/remote',
  //   name: 'RemoteControl',
  //   component: RemoteControl
  // }, {
    path: '/',
    redirect: '/notes'
  }, {
    path: '*',
    component: NotFound
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js